import { render } from "./HistoryDetailOrCompareModal.vue?vue&type=template&id=39e686ee"
import script from "./HistoryDetailOrCompareModal.vue?vue&type=script&lang=js"
export * from "./HistoryDetailOrCompareModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__